// Awrah Guard - tiny theme JS
(function () {
  // PDP: keep <form> variant id in sync with selected option radios
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantInput = form.querySelector('input[name="id"]');
    const variantsScript = form.querySelector('[data-variants-json]');
    if (!variantInput || !variantsScript) return;
    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    const optionInputs = form.querySelectorAll('input[data-option-index]');
    const priceEl = document.querySelector('[data-product-price]');
    const submitBtn = form.querySelector('[data-add-to-cart]');
    const labelEls = form.querySelectorAll('[data-selected-value]');
    const mainImg = document.querySelector('[data-main-image]');

    function currentSelection() {
      const sel = [];
      optionInputs.forEach((input) => {
        if (input.checked) sel[parseInt(input.dataset.optionIndex, 10)] = input.value;
      });
      return sel;
    }

    function update() {
      const sel = currentSelection();
      labelEls.forEach((el) => {
        const idx = parseInt(el.dataset.selectedValue, 10);
        el.textContent = sel[idx] || '';
      });
      const match = variants.find((v) => v.options.every((o, i) => o === sel[i]));
      if (!match) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
        return;
      }
      variantInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
      if (mainImg && match.featured_image) {
        mainImg.src = match.featured_image;
      }
    }

    optionInputs.forEach((input) => input.addEventListener('change', update));
    update();
  });

  // PDP gallery thumbnails
  document.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const url = thumb.dataset.thumb;
      const mainImg = document.querySelector('[data-main-image]');
      if (mainImg && url) mainImg.src = url;
      document.querySelectorAll('[data-thumb]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
})();

// Hero gallery auto cross-fade
(function () {
  const galleries = document.querySelectorAll('[data-hero-gallery]');
  galleries.forEach((gallery) => {
    const slides = gallery.querySelectorAll('.hero__slide');
    if (slides.length < 2) return;
    const interval = parseInt(gallery.dataset.interval, 10) || 4000;
    // Preload
    slides.forEach((s) => { const i = new Image(); i.src = s.src; });

    let idx = 0;
    let timer = null;
    const tick = () => {
      slides[idx].classList.remove('is-active');
      slides[idx].setAttribute('aria-hidden', 'true');
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add('is-active');
      slides[idx].removeAttribute('aria-hidden');
    };
    const start = () => { if (!timer) timer = setInterval(tick, interval); };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    start();
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop(); else start();
    });
  });
})();
